export const DEMO_USER_UUID = '8f8f0d4a-2d7a-4f3b-9a0b-0a5f2b64a7e0'
